<script setup lang="ts">
const props = defineProps<{
  image: string;
}>();

const uniqueId = computed(() => `pattern-${btoa(props.image).replace(/[^a-zA-Z0-9]/g, '')}`);
</script>

<template>
  <div>
    <svg
      class="w-full object-contain"
      viewBox="0 0 363 307"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0960151 6.14497C0.0960151 2.80423 2.80422 0.0960151 6.14497 0.0960151H356.855C360.196 0.0960151 362.904 2.80422 362.904 6.14497V212.286H0.0960151V6.14497Z"
        fill="#EFF0F2"
        stroke="url(#paint0_linear_4_427)"
        stroke-width="0.19203"
      />
      <path
        d="M0 212.382H363V242.718C363 246.111 360.249 248.863 356.855 248.863H6.14496C2.75118 248.863 0 246.111 0 242.718V212.382Z"
        fill="#DFAC98"
      />
      <path
        d="M182.667 4.06346C182.667 4.75858 182.104 5.32192 181.41 5.32192C180.716 5.32192 180.153 4.75858 180.153 4.06346C180.153 3.36834 180.716 2.805 181.41 2.805C182.104 2.805 182.667 3.36834 182.667 4.06346Z"
        fill="#55575E"
        stroke="#3B3B3B"
        stroke-width="0.19203"
      />
      <mask
        id="mask0_4_427"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="180"
        y="3"
        width="2"
        height="2"
      >
        <ellipse
          cx="181.41"
          cy="4.06355"
          rx="0.451044"
          ry="0.451492"
          fill="#494C51"
        />
      </mask>
      <g mask="url(#mask0_4_427)">
        <ellipse
          cx="181.41"
          cy="4.06355"
          rx="0.451044"
          ry="0.451492"
          fill="#494C51"
        />
        <rect
          x="180.959"
          y="3.61206"
          width="0.180427"
          height="0.902985"
          fill="#617189"
        />
        <rect
          x="181.68"
          y="3.61206"
          width="0.180415"
          height="0.902985"
          fill="#617189"
        />
        <ellipse
          cx="181.41"
          cy="4.06338"
          rx="0.270623"
          ry="0.270896"
          fill="#7B6A77"
        />
        <ellipse
          cx="181.5"
          cy="3.97308"
          rx="0.180415"
          ry="0.180597"
          fill="white"
          fill-opacity="0.2"
        />
      </g>
      <rect
        x="138.38"
        y="248.863"
        width="86.2396"
        height="52.5537"
        fill="url(#paint1_linear_4_427)"
      />
      <path
        d="M138.38 301.778H224.62V304.825C224.62 305.037 224.448 305.209 224.236 305.209H138.764C138.552 305.209 138.38 305.037 138.38 304.825V301.778Z"
        fill="#EDB8A3"
      />
      <path
        d="M138.38 301.778H149.927V305.209H138.764C138.552 305.209 138.38 305.037 138.38 304.825V301.778Z"
        fill="url(#paint2_linear_4_427)"
      />
      <path
        d="M224.62 301.778H213.073V305.209H224.236C224.448 305.209 224.62 305.037 224.62 304.825V301.778Z"
        fill="url(#paint3_linear_4_427)"
      />
      <rect
        x="138.38"
        y="301.417"
        width="86.2396"
        height="0.180614"
        fill="#884C37"
      />
      <rect
        x="138.38"
        y="301.597"
        width="86.2396"
        height="0.180591"
        fill="#D3A18F"
      />
      <rect
        x="138.38"
        y="301.778"
        width="86.2396"
        height="0.180591"
        fill="#F4C1AD"
      />
      <path
        d="M139.824 305.209H150.649V305.728C150.649 305.94 150.477 306.112 150.265 306.112H140.208C139.995 306.112 139.824 305.94 139.824 305.728V305.209Z"
        fill="url(#paint4_linear_4_427)"
      />
      <path
        d="M212.351 305.209H223.176V305.728C223.176 305.94 223.004 306.112 222.792 306.112H212.735C212.523 306.112 212.351 305.94 212.351 305.728V305.209Z"
        fill="url(#paint5_linear_4_427)"
      />
      <rect
        x="8.29919"
        y="8.6687"
        width="346.402"
        height="195.045"
        :fill="`url(#${uniqueId})`"
      />
      <defs>
        <pattern
          :id="uniqueId"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <image
            width="1"
            height="1"
            preserveAspectRatio="none"
            :xlink:href="image"
          />
        </pattern>
        <linearGradient
          id="paint0_linear_4_427"
          x1="181.5"
          y1="0"
          x2="181.5"
          y2="212.382"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop
            offset="1"
            stop-color="white"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4_427"
          x1="181.5"
          y1="248.863"
          x2="181.5"
          y2="301.417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C9937F" />
          <stop
            offset="0.504809"
            stop-color="#E4B19C"
          />
          <stop
            offset="0.931918"
            stop-color="#CF9A85"
          />
          <stop
            offset="0.957961"
            stop-color="#F2D3C6"
          />
          <stop
            offset="1"
            stop-color="#935640"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4_427"
          x1="138.38"
          y1="303.313"
          x2="148.213"
          y2="303.313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EAB6A1" />
          <stop
            offset="0.0366972"
            stop-color="#B37963"
          />
          <stop
            offset="0.110092"
            stop-color="#A66A56"
          />
          <stop
            offset="0.380734"
            stop-color="#F5C9B8"
          />
          <stop
            offset="0.572521"
            stop-color="#E3AE99"
          />
          <stop
            offset="1"
            stop-color="#E0AB96"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4_427"
          x1="224.62"
          y1="303.313"
          x2="214.787"
          y2="303.313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EAB6A1" />
          <stop
            offset="0.0366972"
            stop-color="#B37963"
          />
          <stop
            offset="0.110092"
            stop-color="#A66A56"
          />
          <stop
            offset="0.380734"
            stop-color="#F5C9B8"
          />
          <stop
            offset="0.572521"
            stop-color="#E3AE99"
          />
          <stop
            offset="1"
            stop-color="#E0AB96"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4_427"
          x1="145.236"
          y1="305.209"
          x2="145.236"
          y2="306.112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#884C37" />
          <stop
            offset="0.171456"
            stop-color="#985C47"
          />
          <stop
            offset="0.364176"
            stop-color="#D3A18F"
          />
          <stop
            offset="1"
            stop-color="#E7B8A6"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4_427"
          x1="217.764"
          y1="305.209"
          x2="217.764"
          y2="306.112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#884C37" />
          <stop
            offset="0.171456"
            stop-color="#985C47"
          />
          <stop
            offset="0.364176"
            stop-color="#D3A18F"
          />
          <stop
            offset="1"
            stop-color="#E7B8A6"
          />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<style scoped lang="scss">

</style>
